import { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom";
import ReportListSideBar from '../../components/reportssidebar';
import { usePbiLoginMutation, usePbiGetTenantDetailsMutation, usePbiGetUserDetailsMutation, usePbiReportListMutation, usePbiReportDetailsMutation, usePbiGetSubscriptionsMutation, usePbiManualRefreshMutation, usePbiManualRefreshStatusMutation } from '../auth/authApiSlice'
import { setPBICredentials, setTenantWorkspace, setTenantWorkspacelist, setPBIReportList, setSelectedReportDetails, setSelectedReportId, setUserPreference, setReportSelectedIndex, selectReportSelectedIndex, selectSelectedReportId } from '../auth/authSlice'
import { setUserData, setReportId, setSelectedSubscription, setUserSubscription, selectUserData, setSelectedFrequency, setSelectedOffset, setSelectedTimeOffset, setSubscriptionReportID, setIsStandardDB, selectIsStandardDB, selectReportId, setIsAdminAnalytics, setReportFilters, selectIsAdminAnalytics } from '../data/dataSlice'
import Spinner from '../../components/Spinner'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
  IconButton,
} from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ListItemButton from '@mui/material/ListItemButton';
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { selectCurrentUser, selectCurrentToken, selectPBIWorkspace, selectPBIReportList, selectSelectedReportDetails, selectPBIWorkspaceList, selectUserPreference, selectSelectedReport, setSelectedReport, selectReportLastUpadte, setReportLastUpadte } from "../auth/authSlice"
import { tokens } from "../../assets/theme";
import ReportDetails from "./reportdetails"
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import ViewListIcon from '@mui/icons-material/ViewList';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ActionConfirm from '../../components/actionconfirm'
import ReportPermission from '../admindata/reportpermission'
import { timezones } from '../users/timezonelist'
import ExportSubscribeAction from '../../components/expsubs';
import { getObjectFromSessionStorage, updateObjectInSessionStorage } from '../../utils/utils';

const Dashboard = () => {
  const dispatch = useDispatch()
  const user = useSelector(selectCurrentUser)
  const token = useSelector(selectCurrentToken)
  const reportEmbeddObj = useSelector(selectSelectedReportDetails)
  const reportDataObj = useSelector(selectSelectedReport);
  const tenantWorkspaceDetails = useSelector(selectPBIWorkspaceList)
  const reportSelectedIdx = useSelector(selectReportSelectedIndex)
  const reportSelectedID = useSelector(selectSelectedReportId)
  const { locale, defaultCulture } = useSelector(selectUserPreference);
  const isStandardDb = useSelector(selectIsStandardDB);
  const isAdminSelector = useSelector(selectIsAdminAnalytics);
  const lastUpdatedDate = useSelector(selectReportLastUpadte);
  const errRef = useRef()
  const [errMsg, setErrMsg] = useState('')
  const [isReportList, setIsReportList] = useState(true);
  const [spinnerLoad, setSpinnerLoad] = useState(false)
  const [tabvalue, setTabValue] = useState('1');
  const [isAdmin, setIsAdmin] = useState(0);
  const [folder, setFolder] = useState(false);
  const [reportObj, setReportObj] = useState({});
  const [listWidth, setListWidth] = useState("25%");
  //const [refreshClicked, setRefreshClicked] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const navigate = useNavigate()


  dispatch(setSelectedSubscription(null))
  dispatch(setSelectedFrequency("days"))
  dispatch(setSelectedOffset(0))
  dispatch(setSelectedTimeOffset(0))
  const [pbiReportList, { isPBIReportLoading }] = usePbiReportListMutation()
  const [pbiReportDetails, { isPBIReportDetailsLoading }] = usePbiReportDetailsMutation()
  const [pbiManualRefresh, { isPbiManualRefreshLoading }] = usePbiManualRefreshMutation();
  const [pbiManualRefreshStatus, { isPbiManualRefreshStatusLoading }] = usePbiManualRefreshStatusMutation();

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [searchTxt, setSearchTxt] = useState("");

  const tokenAbbr = `${token.slice(0, 9)}...`

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const pbiworkspace = useSelector(selectPBIWorkspace)

  const reportRefreshStatus = getObjectFromSessionStorage('reportRefreshStatus');
  const disableStatus = reportRefreshStatus && reportRefreshStatus[reportDataObj?.datasetId];

  const handleReportClick = async (reportid, workspacedetails, index) => {
    if (reportSelectedID != reportid) {
      dispatch(setReportFilters(null))
      localStorage.setItem('filterdata', JSON.stringify([]));
    }
    dispatch(setSelectedReportId(reportid))
    dispatch(setTenantWorkspace(workspacedetails))
    dispatch(setReportId(reportid))
    const reportDetails = { "workspaceId": workspacedetails, "reportId": reportid, "userId": user }
    const getReportDetails = await pbiReportDetails(reportDetails).unwrap()
    dispatch(setReportSelectedIndex(index))
    setSelectedIndex(index)
    setTimeout(() => {
      dispatch(setSelectedReportDetails(getReportDetails))
    }, 1000);
    navigate('/home')
  }

  const handlePBIReportList = async (workspacedetails, value) => {

    try {
      const workspaceid = { "workspaceId": workspacedetails, "IsUserReportPermission": value == 0 ? false : true }
      setSpinnerLoad(true)
      // let workspaceid = { "workspaceId": "6eacca4f-9e75-400d-8047-74d37d0a9028" }
      const getReportList = await pbiReportList(workspaceid).unwrap()
      if (getReportList && getReportList.reports) {
        let report_list = getReportList.reports;
        let sortedReportList = report_list.slice().sort((a, b) => a.name.localeCompare(b.name))
        setTimeout(() => {
          dispatch(setPBIReportList(sortedReportList))
          if (sortedReportList.length) {
            if (sortedReportList.length > 1 && sortedReportList[0].name.toLocaleLowerCase().includes('_st_db_ecto_bi')) {
              const activereportid = sortedReportList[1].reportId ? sortedReportList[1].reportId : null
              if (activereportid) {
                handleReportClick(activereportid, workspacedetails, 0)
              }
            } else {
              if (!sortedReportList[0].name.toLocaleLowerCase().includes('_st_db_ecto_bi')) {
                const activereportid = sortedReportList[0].reportId ? sortedReportList[0].reportId : null
                if (activereportid) {
                  handleReportClick(activereportid, workspacedetails, 0)
                }
              }
            }
          }

          setSpinnerLoad(false)
          if (sortedReportList.length) {
            const stdbectobi = sortedReportList.filter(report => report.name.toLocaleLowerCase().includes('_st_db_ecto_bi'));
            if (stdbectobi.length) {
              dispatch(setIsStandardDB(true))
            } else {
              dispatch(setIsStandardDB(false))
            }
          }
        }, 1000);
      }

    } catch (err) {
      if (!err?.originalStatus) {
        // isLoading: true until timeout occurs
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      // errRef.current.focus();
    }
  }

  const reportList = useSelector(selectPBIReportList);

  const [view, setView] = useState('list');

  const handleChange = (event, nextView) => {
    setView(nextView);
  };

  const [showSideBar, setShowSideBar] = useState(true);
  const [showListView, setShowListView] = useState(true);
  const [openActionConfirm, setOpenActionConfirm] = useState(false);

  const handleOpenActionConfirm = () => {
    setOpenActionConfirm(true);
  }
  const handleActionConfirmClose = value => {
    setOpenActionConfirm(false);
    if (value != 1) {
      handleReloadReportList();
    }
  }

  const [expanded, setExpanded] = useState([]);
  const [selected, setSelected] = useState([]);
  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };
  const handleSelect = (event, nodeIds) => {
    setSelected(nodeIds);
  };

  const preferencedtimezone = useSelector(selectUserData);
  // const isUserCanCreate = preferencedtimezone && preferencedtimezone.canCreate ? true : false;

  const convertRefreshDateTimezone = datetime => {
    let timezoneabbr = preferencedtimezone && preferencedtimezone.timeZone ? preferencedtimezone.timeZone : "UTC";
    let timezoneobj = timezones.find(item => item.abbr == timezoneabbr);
    let epochval = new Date(datetime).valueOf() + ((timezoneobj.offset ? timezoneobj.offset : 0) * 60 * 60000);
    let lastRefreshDate = new Date(epochval).toISOString().replace('T', ' ').replace('Z', '');
    return lastRefreshDate;
  }

  const handleReloadReportList = () => {
    if (isAdminSelector) {
      handlePBIReportList(pbiworkspace, 0);
    } else {
      handlePBIReportList(pbiworkspace, 1);
    }

  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    let susbcriptionreportidlist = reportList.filter(report => report.name.includes(reportEmbeddObj.name));
    if (susbcriptionreportidlist.length >= 2) {
      let susbcriptionreportpaginated = susbcriptionreportidlist.filter(report => report.name.toLocaleLowerCase().includes('paginated-'));
      if (susbcriptionreportpaginated.length) {
        dispatch(setSubscriptionReportID(susbcriptionreportpaginated[0].reportId))
      }
    }
  };

  useEffect(() => {
    if (reportObj && reportObj.datasetId) {
      dispatch(setSelectedReport(reportObj));
    }
  }, [reportObj])

  useEffect(() => {
    if (lastUpdated && lastUpdated.length > 0) {
      dispatch(setReportLastUpadte(lastUpdated));
    }
  }, [lastUpdated])


  const getReportRefreshStatus = async () => {
    const requestbody = { "datasetId": [reportDataObj.datasetId], "groupId": pbiworkspace }
    let refreshStatus = await pbiManualRefreshStatus(requestbody).unwrap();
    if (refreshStatus && refreshStatus.value.length > 0) {
      setLastUpdated(refreshStatus.value);

      if (refreshStatus.value[0].status == 'Completed') {
        //setRefreshClicked(false);
        updateObjectInSessionStorage('reportRefreshStatus', reportDataObj.datasetId, false);
      }
    }
  }
  useEffect(() => {
    let setInteravalForStatus;
    if (disableStatus) {
      setInteravalForStatus = setInterval(getReportRefreshStatus, 60000 * 1);
    } else {
      clearInterval(setInteravalForStatus);
    }
    return () => clearInterval(setInteravalForStatus);
  }, [disableStatus])


  const handleRefreshReport = async () => {
    try {
      //setRefreshClicked(true);
      updateObjectInSessionStorage('reportRefreshStatus', reportDataObj.datasetId, true);
      const requestBody = {
        datasetId: [reportDataObj.datasetId],
        groupId: pbiworkspace,
        "isEmailNotification": false
      }
      const refreshData = await pbiManualRefresh(requestBody).unwrap();
    } catch (err) {
      console.log(err)
    }
  }

  const handleMouseDown = (e) => {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e) => {
    const newWidth = e.clientX; // Get the current mouse position
    // if (newWidth >= 200 && newWidth <= 500) { // Set min and max width
    setListWidth(newWidth);
    // }
  };

  const handleMouseUp = () => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };
  return (
    <>
      <Box display="flex" className="reportleftbar" justifyContent="space-between">
        <Box
          style={{
            width: `${listWidth}px`,
            minWidth: 0,
            maxWidth: "25%",
            overflow: 'auto',
          }}
          className="resizable-list-section"
        >
          <ReportListSideBar setReportObj={setReportObj} getReportRefreshStatus={getReportRefreshStatus} />
        </Box>
        {/* Draggable Divider */}
        <div
          style={{
            width: '4px',
            cursor: 'col-resize',
            backgroundColor: '#ccc',
            height: "calc(100vh - 62px)",
            marginTop: "5px",
          }}
          onMouseDown={(e) => handleMouseDown(e)}
        ></div>
        {/* Report Details */}
        <Box flex="1 1 auto" ml="15px">
          {(!isAdminSelector || (reportEmbeddObj && reportEmbeddObj.name && reportEmbeddObj.name.toLowerCase().includes('_st_db_ecto_bi'))) && (
            <Box flex="1 1 100%">
              <div class="reportdetail-titlebar">
                <Typography variant="h4" className="title-reportname" component="div" sx={{ flexGrow: 1 }}>
                  {reportEmbeddObj && reportEmbeddObj.name ? reportEmbeddObj.name.toLowerCase().includes('_st_db_ecto_bi') ? "Untitled - Enacto BI" : reportEmbeddObj.name : ""}
                </Typography>
                {reportEmbeddObj && reportEmbeddObj.name && !reportEmbeddObj.name.toLowerCase().includes('_st_db_ecto_bi') && (<ExportSubscribeAction />)}
              </div>
              {reportList.length != 0 && (<ReportDetails />)}
            </Box>
          )}
          {(isAdminSelector && (reportEmbeddObj && reportEmbeddObj.name && !reportEmbeddObj.name.toLowerCase().includes('_st_db_ecto_bi'))) && (
            <Box flex="1 1 100%" ml="15px">
              <div class="reportdetail-titlebar mb0">
                <Typography variant="h4" className="title-reportname" component="div" sx={{ flexGrow: 1 }}>
                  {reportEmbeddObj && reportEmbeddObj.name ? reportEmbeddObj.name : ""}
                </Typography>
                {reportEmbeddObj && reportEmbeddObj.name && tabvalue == "1" && (<ExportSubscribeAction />)}
                {reportEmbeddObj && reportEmbeddObj.name && tabvalue == "2" && (<Button variant="contained" startIcon={<DeleteIcon />} onClick={() => handleOpenActionConfirm()}>Delete Report</Button>)}

              </div>
              <TabContext value={tabvalue}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleTabChange}>
                    <Tab label="Report View" value="1" />
                    <Tab label="Report Permission" value="2" />
                    <IconButton
                      onClick={handleRefreshReport}
                      disabled={disableStatus}
                      value="refresh"
                      aria-label="refresh">
                      <RefreshIcon color={disableStatus ? "disabled" : "primary"} />
                    </IconButton>

                    {lastUpdatedDate && lastUpdatedDate.length > 0 && lastUpdatedDate[0].status === 'Completed' ?
                      <span className="last-updated-date">{`Last Refreshed: ${convertRefreshDateTimezone(lastUpdatedDate[0].endTime)}`}</span> :
                      ''}

                  </TabList>
                </Box>
                <TabPanel className="tabcontent" value="1">{reportList.length != 0 && (<ReportDetails />)}</TabPanel>
                <TabPanel className="tabcontent" value="2"><ReportPermission /></TabPanel>
              </TabContext>
            </Box>
          )}
          <ActionConfirm openActionConfirm={openActionConfirm} handleActionConfirmClose={handleActionConfirmClose} />
        </Box>
      </Box>
      {spinnerLoad && (<Spinner />)}
    </>
  )
}
export default Dashboard